module.exports = __webpack_public_path__ + "ad01c1897e9bce5f69fa1df279e55c63.svg";